/************************************** THIRD-PARTY IMPORTS ***************************************/
import React from 'react';

/***************************************** DEFAULT CONFIG *****************************************/
const defaultHeight = 0.02;

/********************************************* EXPORT *********************************************/
/**
 * Create a vertical and/or horizontal blank space area for element positioning,
 * of given [height] and [width]
 *
 * Unreceived values (width or height) default to 0.02px width, to allow the
 * component to display its location onscreen when highlighted in Chrome
 * devtools
 *
 * Add additional styles with [className]
 */
export const CISpacer = ({
    height,
    width,
    className,
    noDefHeight,
    noDefWidth,
}: {
    height?: number;
    width?: number;
    className?: string;
    noDefHeight?: boolean;
    noDefWidth?: boolean;
}) => (
    <div
        className={className}
        style={{
            height: noDefHeight ? undefined : height || height === 0 ? height : defaultHeight,
            width: noDefWidth ? undefined : width || width === 0 ? width : defaultHeight,
        }}
    />
);

CISpacer.displayName = `CISpacer`;
